import {
  BurgerStyled,
  LinksContainer,
  NavLinkStyled,
  Overlay,
} from "./Burger.styled";
import { Container } from "../Container/Container";
import { useLanguageSchema } from "../../hooks/useLanguageSchema.js";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { setIsOpenBurger } from "../../redux/app/slice.js";
import { LangSwitcher } from "../Header/Header.styled.js";
import clsx from "clsx";
import useLanguage from "../../hooks/useLanguage.js";
import { lang } from "../Header/Header.jsx";

export const Burger = ({ className }) => {
  const dispatch = useDispatch();
  const {
    header: { nav },
  } = useLanguageSchema();
  const [language, setLanguage] = useLanguage();

  const closeBurger = useCallback(() => {
    dispatch(setIsOpenBurger(false));
  }, [dispatch]);

  return (
    <Overlay>
      <BurgerStyled className={className}>
        <Container>
          <LinksContainer>
            {nav.map(({ link, title }, index) => (
              <NavLinkStyled key={index} onClick={closeBurger} to={link}>
                {title}
              </NavLinkStyled>
            ))}
          </LinksContainer>
          <LangSwitcher className="desktop-lang">
            {lang.map((item) => (
              <button
                key={item.code}
                className={clsx("lang-btn", language === item.code && "active")}
                onClick={() => setLanguage(item.code)}
              >
                {item.name}
              </button>
            ))}
          </LangSwitcher>
        </Container>
      </BurgerStyled>
    </Overlay>
  );
};
